import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { generateItemSnippets } from "../util";
import HTMLViewer from "./HTMLViewer";

export default function LineItemDetails(props) {
  const { item, view } = props;
  const [expanded, setExpanded] = useState(false);

  const snippets = generateItemSnippets(item);
  const isMinView = view === "min";
  const maxItems = 2;
  const hasMoreSnippets = snippets.length > maxItems;
  const hasDescription = Boolean(item.description);
  const showViewMore = isMinView && !expanded && (hasMoreSnippets || hasDescription);
  const displaySnippets = isMinView && !expanded ? snippets.slice(0, maxItems) : snippets;

  return (
    <Box pt={0.3}>
      {displaySnippets.map((e, idx) => (
        <Box key={idx} py={0.25}>
          <Typography variant="body2" color="textSecondary">
            {e}
          </Typography>
        </Box>
      ))}
      {showViewMore && (
        <Button
          size="small"
          onClick={() => setExpanded(true)}
          sx={{ mt: 0.5, p: 0, minWidth: 0, textTransform: "none" }}
        >
          VIEW MORE
        </Button>
      )}
      {(!isMinView || expanded) && item.description && (
        <Box my={0.5}>
          <Typography variant="body2" color="textSecondary">
            Notes:
          </Typography>
          <HTMLViewer content={item.description} style={{ fontSize: ".85rem", color: "#6B6B6B" }} />
        </Box>
      )}
    </Box>
  );
}
